import { render, staticRenderFns } from "./BCXPopup.vue?vue&type=template&id=8d4aa904&scoped=true"
import script from "./BCXPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./BCXPopup.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BCXPopup.vue?vue&type=style&index=0&id=8d4aa904&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d4aa904",
  null
  
)

export default component.exports